import { Button, Col, Divider, Input, Row, Typography } from "antd";
import HeaderComponent from "../components/HeaderComponent";
import { StyleSheet } from "../StyleSheet";
import stylesCss from "./payments.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ChangeEvent, useEffect, useMemo, useState } from "react";
import RechargesListComponent from "../components/RechargesListComponent";
import { Paquetes } from "../types/common";
import AlertModal from "../components/AlertModal";

const { Text } = Typography;

type RechargeData = {
    recargar: number;
    mensaje: string;
    numero: string;
    contrato: string;
    tipo_recarga: string;
    paquetes: {
        Id_paquete: string;
        monto: string;
        vigencia: number;
        datos: number;
        minutos: number;
        sms: number;
    }[];
};

const Recharges = () => {
    const location = useLocation();
    const [numberPhone, setNumberPhone] = useState<string>("");
    const [originalNumber, setOriginalNumber] = useState<string>("");
    const [rechargeData, setRechargeData] = useState<RechargeData | null>(null);
    const [selectedPackage, setSelectedPackage] = useState<Paquetes | null>(null);
    const [numberPhoneTmp, setNumberPhoneTmp] = useState<string>("")
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [contractNumber, setContractNumber] = useState<string>("");
    const [confirmNumberError, setConfirmNumberError] = useState<string>("");
    const navigate = useNavigate();

    useEffect(() => {
        const stateData = (location.state as RechargeData | null) || null;

        if (stateData) {
            setRechargeData(stateData);
            setNumberPhone(stateData.numero);
            setOriginalNumber(stateData.numero);
            setContractNumber(stateData.contrato);
            localStorage.setItem("rechargeData", JSON.stringify(stateData));
            return;
        }

        // Si no viene state explícito, limpiar datos previos y redirigir al inicio.
        localStorage.removeItem("rechargeData");
        localStorage.removeItem("numero");
        navigate("/");
    }, [location.state, navigate]);

    const maskedNumber =
        numberPhone.length >= 3
            ? `${numberPhone[0]}${"*".repeat(Math.max(numberPhone.length - 3, 0))}${numberPhone.slice(-2)}`
            : numberPhone;

    const paquetes = useMemo(
        () =>
            [...(rechargeData?.paquetes || [])].sort(
                (a, b) => Number(a.monto) - Number(b.monto)
            ),
        [rechargeData?.paquetes]
    );
    const selectedPackageId = selectedPackage?.Id_paquete ?? null;

    const redirectToPayment = () => {
        setConfirmNumberError("");

        if (!selectedPackage) {
            return;
        }
        if (!numberPhoneTmp) {
            setConfirmNumberError("Confirma tu número para continuar.");
            setModalMessage("Debes confirmar tu número Mega Móvil para continuar.");
            setShowModal(true);
            return;
        }
        if (!phoneMatches) {
            setModalMessage("No se puede continuar porque los números no coinciden.");
            setShowModal(true);
            return;
        }

        const contract = contractNumber || localStorage.getItem("idCliente") || "";

        const rechargePayload = {
            amount: selectedPackage.monto,
            numero: originalNumber,
            idPaquete: selectedPackage.Id_paquete,
            contractNumber: contract
        };

        localStorage.setItem("rechargeAmount", selectedPackage.monto);
        localStorage.setItem("rechargeNumber", originalNumber);
        localStorage.setItem("rechargePackageId", selectedPackage.Id_paquete);
        localStorage.setItem("rechargeContractNumber", contract);

        navigate("/pay-with-card", { state: { recharge: rechargePayload } });
    };

    const phoneMatches = Boolean(originalNumber) && numberPhoneTmp === originalNumber;
    const disablePayButton = !selectedPackage;

    return (
        <>
            <HeaderComponent />
            <Row style={styles.principal} justify={'center'}>
                <Col span={24}>
                    <Row style={styles.rowTitle}>
                        <Text style={styles.textTitle}>
                            Realiza recargas en línea para tu número Mega Móvil
                        </Text>
                    </Row>
                    <Row justify={'center'}>
                        <Divider style={styles.lineDivider} />
                    </Row>
                    <Row style={styles.rowText} justify={'center'}>
                        <Text style={styles.text}>
                            A continuación verás los últimos dígitos de tu línea Mega Móvil.
                            Es necesario conﬁrmar tu número y seleccionar el monto de recarga.
                        </Text>
                    </Row>
                    <Row style={styles.rowText} className={stylesCss.textPayments} justify={'center'}>
                        <Text style={styles.textNameUser}>
                            {maskedNumber}
                        </Text>
                    </Row>
                    <Row style={{ ...styles.rowText, marginTop: 25 }} className={stylesCss.textPayments} justify={'center'}>
                        <Text style={{ color: "black", fontSize: 18, fontWeight: 500 }} >
                            Conﬁrmar tu número telefónico
                        </Text>
                    </Row>
                    <Row justify={'center'}>
                        <Input
                            type="text"
                            placeholder="Ingresa tu número a 10 dígitos"
                            value={numberPhoneTmp}
                            style={styles.input}
                            maxLength={10}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                setConfirmNumberError("");
                                setNumberPhoneTmp(e.target.value.replace(/[^0-9]/g, ""));
                            }}
                        />
                    </Row>
                    {confirmNumberError && (
                        <Row justify={'center'} style={{ marginTop: 6 }}>
                            <Text style={{ color: "#ff4d4f", fontSize: 12 }}>{confirmNumberError}</Text>
                        </Row>
                    )}
                    <RechargesListComponent
                        packages={paquetes}
                        selectedId={selectedPackageId}
                        onSelect={(pkg) => setSelectedPackage(pkg)}
                    />
                    <Row style={{ marginTop: 10 }} justify={'center'}>
                        <Divider style={{ ...styles.lineDivider, marginTop: 35 }} />
                    </Row>
                    <Row className={stylesCss.rowButtons} justify={'center'} style={styles.buttonRow}>
                        <Col style={{ display: "flex", justifyContent: "center" }}>
                            <div className={stylesCss.paypalContainer}>
                                <Button
                                    size='large'
                                    style={{ ...styles.buttonPrimary, backgroundColor: '#172A73' }}
                                    disabled={disablePayButton}
                                    onClick={() => redirectToPayment()}
                                >
                                    Pagar con tarjeta
                                </Button>
                            </div>
                        </Col>
                        <Col style={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                size='large'
                                type="primary"
                                ghost
                                style={styles.buttonReturn}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "#0079FF";
                                    e.currentTarget.style.color = "#ffffff";
                                    e.currentTarget.style.borderColor = "#0079FF";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "transparent";
                                    e.currentTarget.style.color = "#0079FF";
                                    e.currentTarget.style.borderColor = "#0079FF";
                                }}
                                onClick={() => navigate("/")}
                            >
                                Cancelar
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <AlertModal
                title="Advertencia"
                message={modalMessage}
                show={showModal}
                onClose={() => setShowModal(false)}
            />
        </>
    );
};


const styles = StyleSheet.create({
    principal: {
        padding: 15,
        marginBottom: 50,
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonRow: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
    },
    rowTitle: {
        marginTop: 40,
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
    },
    textTitle: {
        fontSize: 23,
        color: 'black',
        fontWeight: 700,
        textAlign: 'center',
        lineHeight: 1.2
    },
    lineDivider: {
        borderColor: '#c4c4c4',
        borderStyle: 'solid',
        borderWidth: 0.01,
        minWidth: "7%",
        width: "7%",
        marginBottom: 10
    },
    rowButtons: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center'
    },
    buttonPrimary: {
        padding: "0px 25px 0px 25px",
        borderRadius: 20,
        color: 'white',
        fontSize: 13,
        width: 300,
        textTransform: "uppercase",
    },
    buttonReturn: {
        backgroundColor: 'transparent',
        borderRadius: 20,
        color: '#0079FF',
        borderColor: '#0079FF',
        fontSize: 13,
        width: 300,
        textTransform: "uppercase",
    },
    rowText: {
        marginTop: 10,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        fontFamily: 'Montserrat',
    },
    text: {
        fontSize: 20,
        color: '#212529',
        fontWeight: 400,
        textAlign: 'center',
        marginTop: 5,
        width: '50%'
    },
    textNameUser: {
        color: '#182b74',
        fontSize: 30,
        fontWeight: 700,
        textAlign: 'center'
    },
    input: {
        width: 380,
        height: 40,
        backgroundColor: "#f0efff",
        textAlign: 'center',
        borderColor: 'transparent',
        marginTop: "1.5rem"
    },
});

export default Recharges;
